import { useHistory } from 'react-router-dom';
import { Session } from '@mindly/ui-components';
import { ConsultationType } from 'src/pages/types';
import { useAnalytics } from './useAnalytics';

export const useSessionRatingAnalytics = (session: Session | ConsultationType) => {
  const { trackPredefinedEvent } = useAnalytics();
  const history = useHistory();

  const sessionData = {
    specialist_id: session?.psychologist_id ?? '',
    specialist_name: session?.psychologist_name ?? '',
    consultation_id: session?.id ?? '',
    subscription_id: session?.subscription_id ?? null,
  };

  return {
    trackScheduleScreenRateSessionClicked: () => {
      trackPredefinedEvent('SCHEDULE_SCREEN_RATE_SESSION_CLICKED', sessionData);
    },
    trackRatingScreenViewed: () => {
      trackPredefinedEvent('RATING_SCREEN_VIEWED', {
        ...sessionData,
        ...(history.location?.pathname ? { rating_screen_place: history.location?.pathname } : {}),
      });
    },
    trackRatingButtonClicked: (ratingValue: number) => {
      trackPredefinedEvent('RATING_BUTTON_CLICKED', {
        ...sessionData,
        rating_value: ratingValue,
      });
    },
    trackReasonTagSelected: (ratingValue: number, ratingReasons: string[]) => {
      trackPredefinedEvent('RATING_REASON_SELECTED', {
        ...sessionData,
        rating_value: ratingValue,
        rating_reasons: ratingReasons,
      });
    },
    trackCommentBlur: (ratingValue: number, ratingReasons: string[], comment: string) => {
      trackPredefinedEvent('RATING_REASON_SELECTED', {
        ...sessionData,
        rating_value: ratingValue,
        rating_reasons: ratingReasons,
        user_comment: (comment ?? '').substring(0, 25),
      });
    },
    trackRatingButtonClosedClicked: () => {
      trackPredefinedEvent('RATING_BUTTON_CLOSED_CLICKED', sessionData);
    },
    trackRatingDiscountOffered: (promocodeValue: string | number, promocodeId: string) => {
      trackPredefinedEvent('RATING_DISCOUNT_OFFERED', {
        consultation_id: session?.id ?? '',
        promocode_value: promocodeValue,
        promocode_id: promocodeId,
      });
    },
    trackRatingNextSessionScreenViewed: () => {
      trackPredefinedEvent('RATING_NEXT_SESSION_SCREEN_VIEWED', sessionData);
    },
    trackRatingNextSessionContinueClicked: () => {
      trackPredefinedEvent('RATING_NEXT_SESSION_CONTINUE_CLICKED', sessionData);
    },
    trackRatingNextSessionCloseClicked: () => {
      trackPredefinedEvent('RATING_NEXT_SESSION_CLOSE_CLICKED', sessionData);
    },
    trackRatingPublicScreenViewed: () => {
      trackPredefinedEvent('RATING_PUBLIC_SCREEN_VIEWED', {
        specialist_id: session?.psychologist_id ?? '',
        specialist_name: session?.psychologist_name ?? '',
      });
    },
    trackRatingPublicRateClicked: (ratingValue: number) => {
      trackPredefinedEvent('RATING_PUBLIC_RATE_CLICKED', {
        specialist_id: session?.psychologist_id ?? '',
        specialist_name: session?.psychologist_name ?? '',
        rating_value: ratingValue,
      });
    },
    trackRatingPublicReviewSubmitted: () => {
      trackPredefinedEvent('RATING_PUBLIC_REVIEW_SUBMITTED', {
        specialist_id: session?.psychologist_id ?? '',
        specialist_name: session?.psychologist_name ?? '',
      });
    },
  };
};
